import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-not-interested',
  template: `
    <div class="ni-container">
      <div class="ni-card">
        <div class="ni-logo">
          <img src="assets/images/logo.png" alt="Evaltrix" 
               onerror="this.src='assets/logo.png'; this.onerror=null;" />
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="ni-loading">
          <div class="ni-spinner"></div>
          <p class="ni-text">Processing your request...</p>
        </div>

        <!-- Success State -->
        <div *ngIf="!loading && success" class="ni-result">
          <div class="ni-icon ni-icon-success">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
          </div>
          <h2 class="ni-title">Unsubscribed Successfully</h2>
          <p class="ni-text">{{ message }}</p>
        </div>

        <!-- Error State -->
        <div *ngIf="!loading && !success" class="ni-result">
          <div class="ni-icon ni-icon-error">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="15" y1="9" x2="9" y2="15"/>
              <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>
          </div>
          <h2 class="ni-title">Action Failed</h2>
          <p class="ni-text">{{ message }}</p>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .ni-container {
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #f5f7fa 0%, #e4e9f0 100%);
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      padding: 20px;
    }

    .ni-card {
      background: #ffffff;
      border-radius: 16px;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
      padding: 48px 40px;
      max-width: 460px;
      width: 100%;
      text-align: center;
    }

    .ni-logo img {
      height: 40px;
      margin-bottom: 32px;
    }

    .ni-loading {
      padding: 24px 0;
    }

    .ni-spinner {
      width: 40px;
      height: 40px;
      border: 3px solid #e8e8e8;
      border-top: 3px solid #1F4EDD;
      border-radius: 50%;
      animation: ni-spin 0.8s linear infinite;
      margin: 0 auto 16px;
    }

    @keyframes ni-spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .ni-result {
      padding: 8px 0;
    }

    .ni-icon {
      margin-bottom: 20px;
    }

    .ni-icon-success {
      color: #22c55e;
    }

    .ni-icon-error {
      color: #ef4444;
    }

    .ni-title {
      font-size: 22px;
      font-weight: 600;
      color: #1a1a2e;
      margin: 0 0 12px 0;
    }

    .ni-text {
      font-size: 15px;
      color: #64748b;
      line-height: 1.6;
      margin: 0;
    }
  `]
})
export class NotInterestedComponent implements OnInit {
  loading = true;
  success = false;
  message = 'Processing your request...';

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    @Inject('BASE_API_URL') private baseUrl: string
  ) { }

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.loading = false;
      this.success = false;
      this.message = 'Invalid request. No token was provided in the link.';
      return;
    }

    const options = { headers: { 'skip-loader': 'true' } };
    this.http.get(`${this.baseUrl}assessment/not-interested?token=${token}`, options).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.success = true;
        this.message = res.message || 'You have been successfully unsubscribed from further reminders for this assessment. No further action is needed.';
      },
      error: (err: any) => {
        this.loading = false;
        this.success = false;
        this.message = err?.error?.message || 'Failed to process your request. The link may be expired or invalid.';
      }
    });
  }
}
